<div [ngClass]="[
    'card',
    branch?.Selected ? 'selected' : '',
    !showSelectionButton ? 'no-selection' : ''
  ]">
  <img *ngIf="branch?.ImageUrl" [src]="branch?.ImageUrl" class="card-img-top thumbnail" [alt]="branch?.LocationName" />
  <div class="card-body">
    <h5 class="card-title">{{ branch?.LocationName }}</h5>
    <div class="card-text">
      <p>
        {{ branch?.Address }}<br />
        {{ branch?.City }}, {{ branch?.State }} {{ branch?.Zip }}
        <br />
        <a [href]="branch ? setGoogleMapsSearch(branch) : ''" target="_blank">View Map</a>
      </p>

      <hr class="hr-style" />

      <p>
        <a href="tel:+{{ branch?.RawPhone }}">
          {{ branch?.Phone }}
        </a>
      </p>

      <p>
        <strong>HOURS:</strong><br />
        {{ branch?.Hours }}
      </p>
    </div>
  </div>
  <div *ngIf="showSelectionButton" class="card-footer">
    <div class="d-grid">
      <ng-container *ngIf="!branch?.Selected; else selected">
        <button class="btn btn-secondary" (click)="onClick(branch?.DomainID!)">
          Select Branch
        </button>
      </ng-container>

      <ng-template #selected>
        <button [disabled]="branch?.Selected" class="btn btn-link" (click)="onClick(branch?.DomainID!)">
          Selected Branch
        </button>
      </ng-template>
    </div>
  </div>
</div>